import React from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { compose, isFunc, appStateStore } from 'shared/helpers';
import { restoreViewState } from 'shared/actions/view';
import { restoreDraftState } from 'shared/actions/draft';

import { withSessionState } from 'components/hocs';



function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    restoreViewState,
    restoreDraftState,
  }, dispatch);
}

/*
 * DecoratedRoute
 *
 * This wraps RR Route component and acts a bit like a middleware for routes.
 * We inject additional props (like sessionState) as well as
 * enforce certain behaviors based on extra props passed in from routes.js.
 */
class DecoratedRoute extends React.Component {
  componentWillMount() {
    // TODO: Other premount action dispatches?

    // If `restore` directive was given via router, then
    // check for saved app state, restore, and remove.
    const { state = {} } = this.props.location || {};
    const { restore = false } = state;
    const appState = appStateStore.get();
    if (restore && appState) {
      this.restoreAppState(appState);
      appStateStore.remove();
    }
  }

  restoreAppState(appState) {
    if (typeof appState !== 'object') {
      return;
    }

    Object.keys(appState).forEach(sub => {
      const rawStateObj = appState[sub];

      switch (sub) {
        case 'view': return this.props.restoreViewState({ rawStateObj });
        case 'draft': return this.props.restoreDraftState({ rawStateObj });
        default: return;
      }
    });
  }

  prepareRoute({ component: Component, sessionState, ...rest }) {
    // Make sessionState available throughout all pages/routes.
    return (
      <Route
        render={props => (
          <Component {...props} sessionState={sessionState} />
        )}
        {...rest}
      />
    );
  }

  render() {
    const { guard = {}, ...props } = this.props;
    const route = this.prepareRoute(props);

    const { ensure, otherwise } = guard;
    if ( ![ ensure, otherwise ].every(isFunc) ) {
      return route;
    }

    // Ensure the conditions are met to return the target Route,
    // otherwise return the alternative.
    return (ensure(props)
      ? route
      : otherwise(props)
    );
  }
}


export default compose(
  connect(null, mapDispatchToProps),
  withSessionState(),
)(DecoratedRoute);



// WEBPACK FOOTER //
// ./src/components/misc/DecoratedRoute.js